(() => {

  const BACKEND = (window.PHIL_BACKEND_URL || "").replace(/\/$/, "");

  function isCoachPage(){
    const p = window.location.pathname || "";
    return p.includes("/pages/phil-ai-coach");
  }

  function coachUrl(){
    const p = window.location.pathname || "";
    return p.startsWith("/en/")
      ? "/en/pages/phil-ai-coach"
      : "/pages/phil-ai-coach";
  }

  function createBubble(){

    if(document.getElementById("phil-avatar-bubble")) return;

    const bubble = document.createElement("div");
    bubble.id = "phil-avatar-bubble";
    bubble.setAttribute("role","button");
    bubble.setAttribute("aria-label","Open Phil AI Coach");

    bubble.innerHTML = `
      <div class="phil-energy"></div>
      <div class="phil-glass"></div>
      <img class="phil-avatar-img"
           src="${BACKEND}/avatar-styleB.png?v=5"
           alt="Phil AI"
           loading="eager"/>
      <div class="phil-cta">Ask Phil</div>
    `;

    bubble.addEventListener("click", () => {
      window.location.assign(coachUrl());
    });

    document.body.appendChild(bubble);
  }

  function injectCoachUI(){

    document.body.classList.add("phil-coach-page");

    const root = document.getElementById("phil-ai-root");
    if(!root) return;

    root.innerHTML = `
      <div class="phil-box">
        <div class="phil-header">
          <img class="phil-avatar" src="${BACKEND}/avatar-styleB.png?v=5" />
          <div>
            <div class="phil-title">Phil AI Coach</div>
            <div class="phil-sub">Golf swing help. Instantly.</div>
          </div>
        </div>

        <div id="phil-messages" class="phil-messages">
          <div class="msg bot">
            Hi — ask me anything about your golf swing.
          </div>
        </div>

        <div class="phil-controls">
          <input id="phil-input" type="text" placeholder="Type your question…" />
          <button id="phil-send">Ask</button>
        </div>
      </div>
    `;

    const input = document.getElementById("phil-input");
    const send = document.getElementById("phil-send");
    const messages = document.getElementById("phil-messages");

    function addMsg(text, who){
      const div = document.createElement("div");
      div.className = "msg " + who;
      div.textContent = text;
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
    }

    async function ask(){
      const q = input.value.trim();
      if(!q) return;

      addMsg(q,"user");
      input.value = "";
      send.disabled = true;

      try{
        const res = await fetch(`${BACKEND}/chat`,{
          method:"POST",
          headers:{ "Content-Type":"application/json" },
          body: JSON.stringify({ message:q })
        });

        const data = await res.json();
        addMsg(data.reply || "No response from server.","bot");

      }catch(e){
        addMsg("Server unavailable. Please try again.","bot");
      }

      send.disabled = false;
      input.focus();
    }

    send.addEventListener("click", ask);
    input.addEventListener("keydown", e=>{
      if(e.key === "Enter") ask();
    });

    input.focus();
  }

  function init(){
    createBubble();
    if(isCoachPage()) injectCoachUI();
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded",init);
  } else {
    init();
  }

})();